import { IAsyncType, useAsync } from '.';
import {
  PaginatedListResponseWarehouseListResponse,
  WarehouseListResponse,
  amsV3Service
} from '../../services';

export interface IWarehouses<T> extends IAsyncType<T> {
  warehouses: T;
}

const useWarehouses = (
  search?: string,
  showInactive: boolean = false
): IWarehouses<WarehouseListResponse[]> => {
  const { data, loading, setLoading, parameters, setParameters } =
    useAsync<PaginatedListResponseWarehouseListResponse>(
      amsV3Service.getWarehouses,
      {
        data: [],
        total: 0,
        page: 0,
        size: 0
      },
      [search, showInactive]
    );
  return {
    warehouses: data?.data ?? [],
    loading,
    setLoading,
    parameters,
    setParameters
  };
};

export default useWarehouses;
